<template>
  <div class="base-segmented-tabs">
    <button
      v-for="tab in tabs"
      :key="tab.key"
      type="button"
      class="base-segmented-tabs__tab"
      :class="{ 'base-segmented-tabs__tab--active': tab.key === activeKey }"
      @click="$emit('change', tab.key)"
    >
      {{ tab.label }}
      <span
        v-if="tab.count !== undefined && tab.count !== null"
        class="base-segmented-tabs__badge"
      >
        {{ tab.count }}
      </span>
    </button>
  </div>
</template>

<script>
export default {
  name: "BaseSegmentedTabs",
  props: {
    tabs: {
      type: Array,
      required: true,
    },
    activeKey: {
      type: String,
      default: null,
    },
  },
};
</script>

<style scoped lang="less">
@import "~@/shared/styles/variables.less";

.base-segmented-tabs {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  background-color: @color-bg-subtle;
  border-radius: 6px;
  padding: 3px;
  flex-shrink: 0;

  &__tab {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    height: 26px;
    padding: 0 11px;
    border: none;
    border-radius: 4px;
    background: transparent;
    font-family: @font-primary;
    font-size: 13px;
    color: @color-text-light;
    cursor: pointer;
    white-space: nowrap;

    &:hover {
      color: @color-primary-dark;
    }

    &--active {
      background: #fff;
      color: @color-primary-dark;
      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
      cursor: default;
    }
  }

  &__badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 18px;
    height: 18px;
    padding: 0 4px;
    border-radius: 9px;
    background-color: @color-badge-neutral-bg;
    font-size: 12px;
    line-height: 1;
    color: inherit;
  }

  &__tab--active &__badge {
    background-color: @color-tag-info-bg;
  }
}
</style>
